/**
 * Pluralizes a word based on a count.
 *
 * @function
 * @param {string} word - The word to pluralize.
 * @param {number} count - The count used to determine the plural form.
 * @returns {string} The pluralized word.
 */
export const pluralizeString = (word: string, count: number): string => {
  if (count === 1) {
    return word;
  }

  // Define irregular plurals in a dictionary
  const irregularPlurals: Record<string, string> = {
    // Add your own irregular plurals here
    // For example: 'person': 'people'
  };

  // Check for irregular plurals
  if (irregularPlurals[word]) {
    return irregularPlurals[word];
  }

  // Define pluralization rules using a lookup table
  const pluralRules: Record<string, string> = {
    s: 'es',
    x: 'es',
    y: 'ies',
  };

  // Apply the pluralization rule if it exists, otherwise add 'es'
  const lastCharacter = word.slice(-1);
  const pluralizedWord = pluralRules[lastCharacter] || 's';

  return `${word}${pluralizedWord}`;
};
